"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = _interopRequireDefault(require("./base"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var opacity = {
  fullMoon50: _objectSpread({}, _base.default.fullMoon, {
    alpha: 0.5
  }),
  midnight50: _objectSpread({}, _base.default.midnight, {
    alpha: 0.5
  }),
  snowWhite15: _objectSpread({}, _base.default.snowWhite, {
    alpha: 0.15
  }),
  snowWhite40: _objectSpread({}, _base.default.snowWhite, {
    alpha: 0.4
  }),
  charcoal15: _objectSpread({}, _base.default.charcoal, {
    alpha: 0.15
  }),
  charcoal40: _objectSpread({}, _base.default.charcoal, {
    alpha: 0.4
  }),
  charcoal75: _objectSpread({}, _base.default.charcoal, {
    alpha: 0.75
  })
};
var _default = opacity;
exports.default = _default;